import home from './home/routes';
import auth from './auth/routes';
import products from './products/routes';
import eyewear from './eyewear/routes';
import generalsettings from './generalsettings/routes';
import webmodule from './webmodule/routes';
import contactus from './contactus/routes';
import support from './support/routes';
import partner from './partner/routes';
import skincarepro from './skincarepro/routes';
import planpricing from './planpricing/routes';
import customer from './customer/routes';
import saasapi from './saasapi/routes';
import customizations from './customizations/routes';
import epf from './epf/routes';

export default function Routes(accountSummary) {
  const getWebmodule = webmodule(accountSummary);
  return [
    home,
    auth,
    products,
    eyewear,
    skincarepro,
    generalsettings,
    support,
    contactus,
    partner,
    planpricing,
    customer,
    getWebmodule,
    saasapi,
    customizations,
    epf,
  ];
}
